import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, CardContent, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Box, CircularProgress, Typography } from '@mui/material';
import RepresentativeTableRow from './RepresentativeTableRow';

const RepresentativesTable = ({ representatives, loading, onEdit, onDelete, onViewStats, canEdit, canDelete }) => {
    const { t } = useTranslation();

    const headCells = [
        { id: 'name', label: t('representatives.name') },
        { id: 'id', label: t('representatives.id') },
        { id: 'phoneNumber', label: t('representatives.phoneNumber') },
        { id: 'age', label: t('representatives.age') },
        { id: 'doctorsCount', label: t('representatives.doctorsCount') },
        { id: 'status', label: t('common.status') },
        { id: 'actions', label: t('common.actions'), align: 'right' },
    ];

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 400 }}>
                <CircularProgress />
            </Box>
        );
    }

    if (representatives.length === 0) {
        return (
            <Box sx={{ textAlign: 'center', py: 5 }}>
                <Typography variant="h6" color="text.secondary">{t('common.noDataFound')}</Typography>
            </Box>
        );
    }

    return (
        <Card>
            <CardContent>
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                {headCells.map((cell) => (
                                    <TableCell key={cell.id} align={cell.align || 'left'}>
                                        {cell.label}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {representatives.map((representative) => (
                                <RepresentativeTableRow
                                    key={representative._id}
                                    representative={representative}
                                    onEdit={onEdit}
                                    onDelete={onDelete}
                                    onViewStats={onViewStats}
                                    canEdit={canEdit}
                                    canDelete={canDelete}
                                />
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </CardContent>
        </Card>
    );
};

export default RepresentativesTable;